const autoNgTemplateLoaderTemplate1 = require('./customer-setup.template.html');

'use strict';

import { NAVIGATION_ICON } from '../../modules/shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../../modules/shared/constants/user-info/solutionType';

(function () {
    angular
        .module('app.customerSetup', [])
        .config(customerSetupConfig);

    customerSetupConfig.$inject = ['$routeProvider'];

    function customerSetupConfig($routeProvider) {
        $routeProvider
            .when('/customer-setup', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'CustomerSetupController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.NUTRITION,
                    breadcrumbs: [
                        { label: 'Customer Setup', icon: NAVIGATION_ICON.PEOPLE_OUTLINE }
                    ]
                }
            })
    }
})();
